<input type="file" (change)="setearFichero($event)"><br>
<button class="btn btn-danger" (click)="subir()">Subir</button>